import { PkDivider } from '@uefadigital/panenka-react';
import parseHtmlToReact from 'html-react-parser';
import { useState, useEffect, useMemo } from 'react';

import type { EditorialContent } from '@cobalt/utilities';
import { useTranslateFn } from '@shared/Translate';
import { dateToString } from '@utilities/dateTime';

export const DefaultContent = ({
  content: { body, classification, title, description, lastModificationDate },
}: {
  content: EditorialContent;
}) => {
  const t = useTranslateFn();
  const [bodyHtml, setBodyHtml] = useState('');

  useEffect(() => {
    if (!body) return;

    const paragraphs = body.filter((bi) => bi._type === 'PARAGRAPH');
    const newBodyHtml = paragraphs.reduce((res: string, bi) => res + bi._html, '');
    setBodyHtml(newBodyHtml);
  }, [body]);

  const roofline = useMemo(() => {
    return `roofline-${classification?.kind?.toLowerCase().replaceAll(' ', '-').replaceAll('/', '-')}`;
  }, [classification]);

  return (
    <div className={`disciplinary-upd__card ${roofline}`}>
      <div className='bg-mc2 p-m'>
        <div className='disciplinary-upd__kind'>{t(roofline)}</div>
        <div className='disciplinary-upd__title'>
          {title}
          <div className='disciplinary-upd__date'>{dateToString(lastModificationDate, 'DD/MM/YYYY HH:mm')}</div>
        </div>
        <div className='disciplinary-upd__description'>{description}</div>
        <PkDivider direction='horizontal' />
        <div className='disciplinary-upd__body'>{parseHtmlToReact(bodyHtml ?? '')}</div>
      </div>
    </div>
  );
};

export default DefaultContent;
